
    module.exports = '0.4.1';



//////////////////
// WEBPACK FOOTER
// ./~/qtek/lib/version.js
// module id = 738
// module chunks = 0